




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import FieldSelectModal from '@/app/components/Plant/FieldSelectModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import PlantDetailApi from '@/app/model/api/plantDetailApi'
import PlantCreateApi from '@/app/model/api/plantCreateApi'
import PlantEditApi from '@/app/model/api/plantEditApi'
import PlantDeleteApi from '@/app/model/api/plantDeleteApi'
import MasterFieldListApi from '@/app/model/api/masterFieldListApi'
import VarietyListApi from '@/app/model/api/varietyListApi'
import VarietyGrowthListApi from '@/app/model/api/varietyGrowthListApi'
import AccountListApi from '@/app/model/api/accountListApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { Chrome } from 'vue-color'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorInfo,
    ErrorModal,
    Error409Modal,
    DeleteModal,
    Loading,
    ChromePicker: Chrome,
    FieldSelectModal,
    Datepicker
  }
})
export default class PlantCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private showFieldSelectModal: boolean = false
  private constantValue: any = []
  private accountData: any = []
  private groupData: any = []
  private varietyData: any = []
  private varietyGrowthData: any = []
  private masterFieldData: any = []
  private selectedField: any[] = []
  private isError: any = {}
  private isDvi: string = 'なし'
  private colors: any = '#FF3535'
  private fieldCount: number = 0
  private varietyId: number = 0
  private beforechangeYear: number = 0
  private plantData: any = {
    planting_group: {
      variety_id: '',
      variety_growth_id: '',
      company_user_id: '',
      group_id: '',
      cultivation_method_id: 1,
      plan_yield_sum: 0,
      planting_type: 1,
      year: 0,
      season_id: 1,
      start_date: null,
      end_date: null,
      color_code: '#FF3535'
    },
    planting_group_actual: {
      actual_yield_sum: 0,
      actual_yield_price: 0,
      income: 0,
      remarks: ''
    },
    plantings: []
  }
  private stemNumberType: any = [
    { text: '本/株', value: 1 },
    { text: '本/平米', value: 2 },
    { text: '両方', value: 3 }
  ]
  private isSelectedField: any = []
  private deleteTargetFieldId: number = 0
  private deleteModalType: any = 0
  /* 表示非表示 */
  private show400ErrorMessage: boolean = false
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showColorPicker: boolean = false
  private isDelete: boolean = true
  private showLoading: boolean = true
  private isEdit: boolean = false
  private showError409Modal: boolean = false
  private isInitialDisplay: boolean = true
  /* datepicker */
  private startDate: any = ''
  private endDate: any = ''
  private plantDate: any = ''
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'
  private start: any = ''
  private end: any = ''

  private get changeVariety (): number {
    return this.varietyId
  }

  @Watch('changeVariety')
  changeIsDvi (varietyId: number) {
    for (let i in this.varietyData) {
      if (this.varietyData[i].variety_id === varietyId) {
        this.isDvi = this.varietyData[i].is_dvi
      }
    }
  }

  created () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getAccountList()
    this.getVarietyList()
    this.getVarietyGrowthList()
    this.getMasterFieldList()

    if (this.$route.path === '/plant/create') {
      this.isEdit = false
      // 新規の場合
      this.plantData.planting_group.year = new Date().getFullYear()
      this.plantData.planting_group.start_date = new Date()
      this.plantData.planting_group.end_date = new Date()
      // 終了日は明日の日付
      const year = this.plantData.planting_group.end_date.getFullYear()
      const month = this.plantData.planting_group.end_date.getMonth()
      const date = this.plantData.planting_group.end_date.getDate() + 1
      this.plantData.planting_group.end_date = new Date(year, month, date)
      this.selectedStart(this.plantData.planting_group.start_date)
      this.selectedEnd(this.plantData.planting_group.end_date)

      this.showLoading = false
    } else {
      this.isEdit = true
      this.getPlantList()
    }
  }

  private yearCheck () {
    if (isNaN(this.plantData.planting_group.year) || this.plantData.planting_group.year.toString().length !== 4) {
      this.plantData.planting_group.year = this.beforechangeYear
    }
  }

  private getVarietyName (id: number) {
    for (let i in this.varietyGrowthData) {
      if (this.varietyGrowthData[i].variety_growth_id === id) {
        this.varietyId = this.varietyGrowthData[i].variety_id
        return this.varietyGrowthData[i].variety_name
      }
    }
    return '(品種生育を選択してください)'
  }

  // 品種情報取得
  private getVarietyList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'created_at',
        sort: false
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから圃場を追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // 品種生育情報取得
  private getVarietyGrowthList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'variety_growth_name',
        sort: true,
        limit: 1000,
        page: 1
      }

      const result = await VarietyGrowthListApi.getVarietyGrowthList(data)

      if (result.isOk()) {
        this.varietyGrowthData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種生育が未登録です。品種生育を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // 生産者情報取得
  private getAccountList () {
    (async () => {
      const data = {
        type: 0,
        text: '',
        num: 2,
        sort: 'asc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        this.accountData = result.getPayload().users
        this.groupData = result.getPayload().groups
        if (result.getPayload().total_user === 0) {
          this.alertText = ''
          this.alertTitle = '生産者が未登録です。生産者を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private showDefultDeleteModal () {
    this.deleteModalType = 0
    this.showDeleteModal = true
  }

  private showDeleteFieldModal (fieldId: number) {
    this.deleteModalType = 1
    this.showDeleteModal = true
    this.deleteTargetFieldId = fieldId
  }

  private doFieldDelete () {
    for (let i in this.plantData.plantings) {
      if (this.deleteTargetFieldId === this.plantData.plantings[i].field_id) {
        this.plantData.plantings.splice(i, 1)
      }
    }
    this.deleteTargetFieldId = 0
    this.showDeleteModal = false
  }

  private doDelete () {
    if (this.deleteTargetFieldId === 0) {
      this.doPlantDelete()
    } else {
      this.doFieldDelete()
    }
  }

  private closeDeleteModal () {
    this.deleteTargetFieldId = 0
    this.showDeleteModal = false
  }

  // 入力値に合わせて背景色・カラーピッカーの設定
  private colorSetting () {
    if (this.plantData.planting_group.color_code === '') {
      this.colors = '#FF3535'
    } else {
      this.colors = this.plantData.planting_group.color_code
    }
  }

  private closeColorPicker () {
    if (this.colors.hex === undefined) {
      this.plantData.planting_group.color_code = '#FF3535'
      this.colors = '#FF3535'
    } else {
      this.plantData.planting_group.color_code = this.colors.hex
      this.colors = this.colors.hex
    }
    this.showColorPicker = false
  }

  // 見込収量計算
  private sumPlanYield () {
    if (this.plantData.plantings.length !== 0) {
      let sum = 0
      let isAllNull = true
      for (let i in this.plantData.plantings) {
        if (this.plantData.plantings[i].plan_yield !== null) {
          isAllNull = false
          sum = sum + this.plantData.plantings[i].plan_yield
        }
      }
      if (isAllNull || isNaN(sum)) {
        this.plantData.planting_group.plan_yield_sum = 0
      } else {
        this.plantData.planting_group.plan_yield_sum = sum
      }
    } else {
      this.plantData.planting_group.plan_yield_sum = 0
    }
  }

  // 収量計算
  private sumActualYield () {
    if (this.plantData.plantings.length !== 0) {
      let sum = 0
      for (let i in this.plantData.plantings) {
        sum = sum + this.plantData.plantings[i].actual_yield
      }
      if (isNaN(sum)) {
        this.plantData.planting_group_actual.actual_yield_sum = 0
      } else {
        this.plantData.planting_group_actual.actual_yield_sum = sum
      }
    } else {
      this.plantData.planting_group_actual.actual_yield_sum = 0
    }

    this.calculationIncome()
  }

  // 収入計算
  private calculationIncome () {
    if (this.plantData.plantings.length !== 0) {
      const income = Math.floor((this.plantData.planting_group_actual.actual_yield_sum / 60) * this.plantData.planting_group_actual.actual_yield_price)
      if (isNaN(income)) {
        this.plantData.planting_group_actual.income = 0
      } else {
        this.plantData.planting_group_actual.income = income
      }
    } else {
      this.plantData.planting_group_actual.income = 0
    }
  }

  // 見込収量計算
  private calculationPlanYield (fieldId: number) {
    for (let i in this.plantData.plantings) {
      if (fieldId === this.plantData.plantings[i].field_id) {
        // 見込反収kg/a(見込反収(kg/10a)÷10) × 圃場面積a(圃場面積(ha)×100)
        const planYield = (this.plantData.plantings[i].expected_harvest / 10) * (this.plantData.plantings[i].field_area * 100)
        if (this.plantData.plantings[i].expected_harvest === null || isNaN(planYield)) {
          this.plantData.plantings[i].plan_yield = null
        } else {
          this.plantData.plantings[i].plan_yield = Math.floor(planYield)
        }
      }
    }
    this.sumPlanYield()
  }

  // 植栽密度
  private calculationPlantingDensity () {
    for (let i in this.plantData.plantings) {
      if (this.plantData.plantings[i].planting_space_x !== null && this.plantData.plantings[i].planting_space_y !== null) {
        const val = 1 / (this.plantData.plantings[i].planting_space_x * this.plantData.plantings[i].planting_space_y * 0.0001)
        if (val === 0 || val === Infinity) {
          this.plantData.plantings[i].planting_density = 0
        } else if (val < 0.01) {
          this.plantData.plantings[i].planting_density = 0.01
        } else {
          this.plantData.plantings[i].planting_density = Math.round(val * 100) / 100
        }
      } else {
        this.plantData.plantings[i].planting_density = null
      }
    }
  }

  private upYearNumber () {
    this.plantData.planting_group.year = parseInt(this.plantData.planting_group.year) + 1
  }

  private downYearNumber () {
    this.plantData.planting_group.year = parseInt(this.plantData.planting_group.year) - 1
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null) {
      return null
    }
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string, key3: string) {
    let before
    if (key1 === 'planting_group_actual') {
      before = String(this.plantData[key1][key3])
    } else {
      before = String(this.plantData[key1][key2][key3])
    }

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    if (key1 === 'planting_group_actual') {
      if (isNaN(parseFloat(after))) {
        this.plantData[key1][key3] = 0
      } else {
        this.plantData[key1][key3] = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.plantData[key1][key2][key3] = null
      } else {
        this.plantData[key1][key2][key3] = parseFloat(after)
      }
    }
  }

  private getMasterFieldList () {
    (async () => {
      const data = {
        word: this.$store.state.plantState.fieldSearchText,
        sensor_word: '',
        order_name: this.$store.state.plantState.fieldOrderName,
        sort: this.$store.state.plantState.fieldSortAsc,
        page: this.$store.state.plantState.fieldCurrentPage
      }

      const result = await MasterFieldListApi.getMasterFieldList(data)

      if (result.isOk()) {
        this.masterFieldData = result.getPayload().results
        this.fieldCount = result.getPayload().total_count
        if (this.isInitialDisplay && this.fieldCount === 0) {
          this.alertText = ''
          this.alertTitle = '圃場が未登録です。圃場を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.isInitialDisplay = false
    })()
  }

  private getSelectedFieldList (fields: any) {
    this.showFieldSelectModal = false
    const afterSelectField = []
    for (let j in fields) {
      afterSelectField.push(fields[j].field_id)
    }
    const beforeSelectField = []
    for (let j in this.plantData.plantings) {
      beforeSelectField.push(this.plantData.plantings[j].field_id)
    }
    // 削除されていたら消す
    for (let i in beforeSelectField) {
      if (!afterSelectField.includes(beforeSelectField[i])) {
        for (let l in this.plantData.plantings) {
          if (this.plantData.plantings[l].field_id === beforeSelectField[i]) {
            this.plantData.plantings.splice(l, 1)
          }
        }
      }
    }
    // 新しく追加されていたら追加
    for (let k in afterSelectField) {
      if (!beforeSelectField.includes(afterSelectField[k])) {
        this.plantData.plantings.push({
          planting_id: 0,
          field_id: fields[k].field_id,
          field_name: fields[k].field_name,
          area_name: fields[k].area_name,
          district_name: fields[k].district_name,
          group_name: fields[k].group_name,
          field_area: fields[k].field_area,
          plan_grade: 1,
          actual_grade: null,
          expected_harvest: null,
          plan_yield: null,
          actual_yield: null,
          leaf_age: null,
          planting_date: new Date(),
          is_delete_flag: 0,
          harvest_actual_date: null,
          taste_rank_id: null,
          stem_number_type: 1,
          protein_content: null,
          planting_link: null,
          planting_space_y: null,
          planting_space_x: null,
          planting_density: null,
          midsummer_drainage_goal_start_date: null,
          midsummer_drainage_goal_duration: null
        })
      }
    }
    this.isSelectedField = []
  }

  private createDisplayDate (e: any) {
    const i = e.toString()
    const year = i.slice(0, 4)
    let month = i.slice(5, 7)
    const date = i.slice(8, 10)
    month = parseInt(month) - 1
    return new Date(year, month, date)
  }

  private createDisplayStringDate (e: any) {
    const i = e.toString()
    const year = i.slice(0, 4)
    let month = i.slice(5, 7)
    const date = i.slice(8, 10)
    return year + '-' + month + '-' + date
  }

  private selectedStart (e: any) {
    const year = e.getFullYear()
    const month = e.getMonth()
    const date = e.getDate() + 1

    this.start = new Date(year, month, date)
  }

  private selectedEnd (e: any) {
    const year = e.getFullYear()
    const month = e.getMonth()
    const date = e.getDate()

    this.end = new Date(year, month, date)
  }

  private createYYYYmmdd (e: any) {
    if (!e) {
      return e
    } else if (String(e).length === 8) {
      return e
    } else {
      const year = String(e.getFullYear())
      const month = '0' + String(e.getMonth() + 1)
      const day = '0' + String(e.getDate())
      return parseInt(year + month.slice(-2) + day.slice(-2))
    }
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isPlantCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    if (this.isEdit) {
      this.plantEdit()
    } else {
      this.plantCreate()
    }
  }

  private getPlantList () {
    (async () => {
      const result = await PlantDetailApi.getPlantDetail(this.$route.params.plant_id)
      if (result.isOk()) {
        this.plantData = result.getPayload()
        // カラーコードセット
        if (this.plantData.planting_group.color_code === '') {
          this.colors = '#FF3535'
        } else {
          this.colors = this.plantData.planting_group.color_code
        }
        for (let i in this.plantData.plantings) {
          this.selectedField.push(this.plantData.plantings[i])
        }
        // キー名が違うため変更
        // 生産者
        this.plantData.planting_group.company_user_id = this.plantData.planting_group.producer_id
        delete this.plantData.planting_group.producer_id
        // 栽培方法
        for (let i in this.constantValue.cultivation_methods) {
          if (this.constantValue.cultivation_methods[i].cultivation_method_name === this.plantData.planting_group.planting_cultivation_method_name) {
            this.plantData.planting_group.cultivation_method_id = this.constantValue.cultivation_methods[i].cultivation_method_id
          }
        }
        delete this.plantData.planting_group.planting_cultivation_method_name
        // datepiker用に整形
        for (let j in this.plantData.plantings) {
          this.plantData.plantings[j].planting_date = this.createDisplayDate(this.plantData.plantings[j].planting_date)
          if (this.plantData.plantings[j].harvest_actual_date !== null) {
            this.plantData.plantings[j].harvest_actual_date = this.createDisplayStringDate(this.plantData.plantings[j].harvest_actual_date)
          }
        }
        this.plantData.planting_group.start_date = this.createDisplayDate(this.plantData.planting_group.start_date)
        this.plantData.planting_group.end_date = this.createDisplayDate(this.plantData.planting_group.end_date)
        this.selectedStart(this.plantData.planting_group.start_date)
        this.selectedEnd(this.plantData.planting_group.end_date)
        // 中干し
        for (const p of this.plantData.plantings) {
          if (p.midsummer_drainage_goal_start_date) {
            const diff = new Date(p.midsummer_drainage_goal_end_date).getTime() - new Date(p.midsummer_drainage_goal_start_date).getTime()
            p.midsummer_drainage_goal_start_date = this.createDisplayDate(p.midsummer_drainage_goal_start_date)
            p.midsummer_drainage_goal_duration = diff / (1000 * 60 * 60 * 24) + 1
          } else {
            p.midsummer_drainage_goal_duration = null
          }
          delete p.midsummer_drainage_goal_end_date
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  // 作付け登録
  private async plantCreate () {
    let plantings: any = []
    for (let i in this.plantData.plantings) {
      let data = this.plantData.plantings[i]
      let mdEndDate = null
      if (data.midsummer_drainage_goal_start_date && data.midsummer_drainage_goal_duration) {
        mdEndDate = new Date(data.midsummer_drainage_goal_start_date)
        mdEndDate.setDate(mdEndDate.getDate() + (data.midsummer_drainage_goal_duration - 1))
      }
      plantings.push({
        field_id: data.field_id,
        planting_date: this.createYYYYmmdd(data.planting_date),
        planting_id: 0,
        plan_grade: data.plan_grade,
        actual_grade: data.actual_grade,
        expected_harvest: data.expected_harvest,
        plan_yield: data.plan_yield,
        actual_yield: data.actual_yield,
        leaf_age: data.leaf_age,
        taste_rank_id: data.taste_rank_id,
        protein_content: data.protein_content,
        planting_link: data.planting_link,
        stem_number_type: data.stem_number_type,
        planting_space_x: data.planting_space_x,
        planting_space_y: data.planting_space_y,
        planting_density: data.planting_density,
        midsummer_drainage_goal_start_date: this.createYYYYmmdd(data.midsummer_drainage_goal_start_date),
        midsummer_drainage_goal_end_date: this.createYYYYmmdd(mdEndDate),
        is_delete_flag: 0
      })
    }

    const body: any = {
      planting_group: {
        variety_id: this.plantData.planting_group.variety_id,
        variety_growth_id: this.plantData.planting_group.variety_growth_id,
        company_user_id: this.plantData.planting_group.company_user_id,
        group_id: this.plantData.planting_group.group_id,
        cultivation_method_id: this.plantData.planting_group.cultivation_method_id,
        plan_yield_sum: this.plantData.planting_group.plan_yield_sum,
        planting_type: this.plantData.planting_group.planting_type,
        year: parseInt(this.plantData.planting_group.year),
        season_id: this.plantData.planting_group.season_id,
        start_date: this.createYYYYmmdd(this.plantData.planting_group.start_date),
        end_date: this.createYYYYmmdd(this.plantData.planting_group.end_date),
        color_code: this.plantData.planting_group.color_code,
        time_stamp: this.plantData.planting_group.time_stamp
      },
      planting_group_actual: {
        actual_yield_price: this.plantData.planting_group_actual.actual_yield_price,
        actual_yield_sum: this.plantData.planting_group_actual.actual_yield_sum,
        income: this.plantData.planting_group_actual.income,
        remarks: this.plantData.planting_group_actual.remarks
      },
      plantings: plantings
    }

    const result = await PlantCreateApi.doPlantCreate(body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '作付け登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/plant').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async plantEdit () {
    let plantings: any = []
    for (let i in this.plantData.plantings) {
      let data = this.plantData.plantings[i]
      let mdEndDate = null
      if (data.midsummer_drainage_goal_start_date && data.midsummer_drainage_goal_duration) {
        mdEndDate = new Date(data.midsummer_drainage_goal_start_date)
        mdEndDate.setDate(mdEndDate.getDate() + (data.midsummer_drainage_goal_duration - 1))
      }
      plantings.push({
        field_id: data.field_id,
        planting_date: this.createYYYYmmdd(data.planting_date),
        planting_id: data.planting_id,
        plan_grade: data.plan_grade,
        actual_grade: data.actual_grade,
        expected_harvest: data.expected_harvest,
        plan_yield: data.plan_yield,
        actual_yield: data.actual_yield,
        leaf_age: data.leaf_age,
        taste_rank_id: data.taste_rank_id,
        protein_content: data.protein_content,
        planting_link: data.planting_link,
        stem_number_type: data.stem_number_type,
        planting_space_x: data.planting_space_x,
        planting_space_y: data.planting_space_y,
        planting_density: data.planting_density,
        midsummer_drainage_goal_start_date: this.createYYYYmmdd(data.midsummer_drainage_goal_start_date),
        midsummer_drainage_goal_end_date: this.createYYYYmmdd(mdEndDate),
        is_delete_flag: data.is_delete_flag
      })
    }
    const afterSelectField = []
    for (let j in this.plantData.plantings) {
      afterSelectField.push(this.plantData.plantings[j].field_id)
    }
    const beforeSelectField = []
    for (let j in this.selectedField) {
      beforeSelectField.push(this.selectedField[j].field_id)
    }
    for (let i in this.selectedField) {
      // 既存の圃場を削除した(再追加もなしの)場合is_delete_flag=1
      if (!afterSelectField.includes(this.selectedField[i].field_id)) {
        plantings.push({
          field_id: 0,
          planting_id: this.selectedField[i].planting_id,
          is_delete_flag: 1
        })
      // 既存の圃場を削除して再度追加してる場合、既存の方はis_delete_flag=1
      } else {
        for (let j in this.plantData.plantings) {
          if (this.selectedField[i].field_id === this.plantData.plantings[j].field_id) {
            if (this.plantData.plantings[j].planting_id === 0) {
              plantings.push({
                field_id: 0,
                planting_id: this.selectedField[i].planting_id,
                is_delete_flag: 1
              })
            }
          }
        }
      }
    }
    // 更新の場合はis_delete_flag=0
    for (let i in plantings) {
      if (plantings[i].is_delete_flag === undefined) {
        plantings[i].is_delete_flag = 0
      }
    }

    const body = {
      planting_group: {
        variety_id: this.plantData.planting_group.variety_id,
        variety_growth_id: this.plantData.planting_group.variety_growth_id,
        company_user_id: this.plantData.planting_group.company_user_id,
        group_id: this.plantData.planting_group.group_id,
        cultivation_method_id: this.plantData.planting_group.cultivation_method_id,
        plan_yield_sum: this.plantData.planting_group.plan_yield_sum,
        year: parseInt(this.plantData.planting_group.year),
        season_id: this.plantData.planting_group.season_id,
        start_date: this.createYYYYmmdd(this.plantData.planting_group.start_date),
        end_date: this.createYYYYmmdd(this.plantData.planting_group.end_date),
        color_code: this.plantData.planting_group.color_code,
        time_stamp: this.plantData.planting_group.time_stamp
      },
      planting_group_actual: {
        actual_yield_price: this.plantData.planting_group_actual.actual_yield_price,
        actual_yield_sum: this.plantData.planting_group_actual.actual_yield_sum,
        income: this.plantData.planting_group_actual.income,
        remarks: this.plantData.planting_group_actual.remarks
      },
      plantings: plantings
    }
    const result = await PlantEditApi.doPlantEdit(this.$route.params.plant_id, body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '作付け編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/plant').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private isPlantCreate () {
    for (let i in this.errorMessages) {
      this.$delete(this.errorMessages, i)
    }

    const varietyGrowthNameFlag = Validator.validateSelectVarietyGrowthName('varietyGrowthNameErrorMessage', this.plantData.planting_group.variety_growth_id)
    const userNameFlag = Validator.validateSelectUserName('userNameErrorMessage', this.plantData.planting_group.company_user_id)
    const groupNameFlag = Validator.validateInputGroup('groupNameErrorMessage', this.plantData.planting_group.group_id)
    const actualYieldPriceFlag = Validator.validateInputActualYieldPrice('actualYieldPriceErrorMessage', this.plantData.planting_group_actual.actual_yield_price)
    const actualYieldSumFlag = Validator.validateInputActualYieldSum('actualYieldSumErrorMessage', this.plantData.planting_group_actual.actual_yield_sum)
    const incomeFlag = Validator.validateInputIncome('incomeErrorMessage', this.plantData.planting_group_actual.income)
    const planYieldSumFlag = Validator.validateInputPlanYieldSum('planYieldSumErrorMessage', this.plantData.planting_group.plan_yield_sum)
    const fieldColorFlag = Validator.validateInputPlantColor('fieldColorErrorMessage', this.plantData.planting_group.color_code)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true

    const start = new Date(this.plantData.planting_group.start_date.getFullYear(), this.plantData.planting_group.start_date.getMonth() + 1, this.plantData.planting_group.start_date.getDate(), 0, 0, 0)
    const end = new Date(this.plantData.planting_group.end_date.getFullYear(), this.plantData.planting_group.end_date.getMonth() + 1, this.plantData.planting_group.end_date.getDate(), 0, 0, 0)

    // 終了日は開始日の翌年2月末まで
    const endMaxDate = new Date(this.plantData.planting_group.start_date.getFullYear() + 1, 2, 1, 0, 0, 0)
    if (this.plantData.planting_group.end_date >= endMaxDate) {
      this.$set(this.errorMessages, 'endDateErrorMessage', '終了日は開始日の翌年2月までの範囲で入力してください。')
      isError = false
    }

    for (let i in this.plantData.plantings) {
      const data = this.plantData.plantings[i]
      // 播種日バリデーション
      const date = new Date(data.planting_date.getFullYear(), data.planting_date.getMonth() + 1, data.planting_date.getDate(), 0, 0, 0)
      if (date < start || date > end) {
        this.$set(this.errorMessages, 'plantingDateErrorMessage', '播種/移植日は作付け開始日から終了日の期間内で入力してください。')
        isError = false
        this.$set(this.isError, 'planting_date' + i, true)
      } else {
        this.$set(this.isError, 'planting_date' + i, false)
      }
      // 見込反収バリデーション
      if (data.expected_harvest !== null) {
        if (data.expected_harvest < 0 || data.expected_harvest > 100000000) {
          this.$set(this.errorMessages, 'expectedHarvestErrorMessage', '見込反収は0以上100,000,000以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'expected_harvest' + i, true)
        } else if (!Number.isInteger(data.expected_harvest)) {
          this.$set(this.errorMessages, 'expectedHarvestErrorMessage', '見込反収は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'expected_harvest' + i, true)
        } else {
          this.$set(this.isError, 'expected_harvest' + i, false)
        }
      } else {
        this.$set(this.isError, 'expected_harvest' + i, false)
      }
      // 見込収量バリデーション
      if (data.plan_yield !== null) {
        if (data.plan_yield < 0 || data.plan_yield > 100000000) {
          this.$set(this.errorMessages, 'fieldPlanYieldErrorMessage', '見込収量は0以上100,000,000以下の範囲ではありません。')
          isError = false
          this.$set(this.isError, 'plan_yield' + i, true)
        } else {
          this.$set(this.isError, 'plan_yield' + i, false)
        }
      } else {
        this.$set(this.isError, 'plan_yield' + i, false)
      }
      // 実績収量バリデーション
      if (data.actual_yield !== null) {
        if (data.actual_yield < 0 || data.actual_yield > 100000000) {
          this.$set(this.errorMessages, 'actualYieldErrorMessage', '実績収量は0以上100,000,000以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'actual_yield' + i, true)
        } else if (!Number.isInteger(data.actual_yield)) {
          this.$set(this.errorMessages, 'actualYieldErrorMessage', '実績収量は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'actual_yield' + i, true)
        } else {
          this.$set(this.isError, 'actual_yield' + i, false)
        }
      } else {
        this.$set(this.isError, 'actual_yield' + i, false)
      }
      // 葉齢バリデーション
      if (data.leaf_age !== null) {
        if (data.leaf_age < 0 || data.leaf_age > 100) {
          this.$set(this.errorMessages, 'leafAgeErrorMessage', '葉齢は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'leaf_age' + i, true)
        } else if (!Number.isInteger(data.leaf_age)) {
          this.$set(this.errorMessages, 'leafAgeErrorMessage', '葉齢は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'leaf_age' + i, true)
        } else {
          this.$set(this.isError, 'leaf_age' + i, false)
        }
      } else {
        this.$set(this.isError, 'leaf_age' + i, false)
      }
      // たんぱく含有率バリデーション
      if (data.protein_content !== null) {
        let num = data.protein_content.toString().split('.')
        if (data.protein_content < 0 || data.protein_content > 100) {
          this.$set(this.errorMessages, 'proteinContentErrorMessage', 'たんぱく含有率は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'protein_content' + i, true)
        } else if (num[1] !== undefined && num[1].length > 1) {
          this.$set(this.errorMessages, 'proteinContentErrorMessage', 'たんぱく含有率は小数点第1位までの範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'protein_content' + i, true)
        } else {
          this.$set(this.isError, 'protein_content' + i, false)
        }
      } else {
        this.$set(this.isError, 'protein_content' + i, false)
      }
      // 関連リンクバリデーション
      if (data.planting_link !== null) {
        if (data.planting_link.length > 2000) {
          this.$set(this.errorMessages, 'plantingLinkErrorMessage', '関連リンクは2,000文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'planting_link' + i, true)
        } else {
          this.$set(this.isError, 'planting_link' + i, false)
        }
      } else {
        this.$set(this.isError, 'planting_link' + i, false)
      }
      // 植栽間隔-縦
      if (data.planting_space_y !== null) {
        let num = data.planting_space_y.toString().split('.')
        if (num[1] !== undefined) {
          this.$set(this.errorMessages, 'plantingSpaceYErrorMessage', '植栽間隔縦(cm)は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'planting_space_y' + i, true)
        } else if (data.planting_space_y > 1000 || data.planting_space_y < 0) {
          this.$set(this.errorMessages, 'plantingSpaceYErrorMessage', '植栽間隔縦(cm)は0以上1000以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'planting_space_y' + i, true)
        } else {
          this.$set(this.isError, 'planting_space_y' + i, false)
        }
      } else {
        this.$set(this.isError, 'planting_space_y' + i, false)
      }
      // 植栽間隔-横
      if (data.planting_space_x !== null) {
        let num = data.planting_space_x.toString().split('.')
        if (num[1] !== undefined) {
          this.$set(this.errorMessages, 'plantingSpaceXErrorMessage', '植栽間隔横(cm)は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'planting_space_x' + i, true)
        } else if (data.planting_space_x > 1000 || data.planting_space_x < 0) {
          this.$set(this.errorMessages, 'plantingSpaceXErrorMessage', '植栽間隔横(cm)は0以上1000以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'planting_space_x' + i, true)
        } else {
          this.$set(this.isError, 'planting_space_x' + i, false)
        }
      } else {
        this.$set(this.isError, 'planting_space_x' + i, false)
      }
      // 植栽密度
      if (data.planting_density !== null) {
        if (data.planting_density < 0 || data.planting_density > 10000) {
          this.$set(this.errorMessages, 'plantingDensityErrorMessage', '植栽密度は0以上10,000以下の範囲ではありません。')
          isError = false
          this.$set(this.isError, 'planting_density' + i, true)
        } else {
          this.$set(this.isError, 'planting_density' + i, false)
        }
      } else {
        this.$set(this.isError, 'planting_density' + i, false)
      }
      // 中干し開始日
      if (data.midsummer_drainage_goal_start_date !== null) {
        const date = new Date(data.midsummer_drainage_goal_start_date.getFullYear(), data.midsummer_drainage_goal_start_date.getMonth() + 1, data.midsummer_drainage_goal_start_date.getDate(), 0, 0, 0)
        if (date < start || date > end) {
          this.$set(this.errorMessages, 'midsummerDrainageGoalStartDateErrorMessage', '中干し開始日は作付け開始日から終了日の期間内で入力してください。')
          isError = false
          this.$set(this.isError, 'midsummer_drainage_goal_start_date' + i, true)
        } else {
          this.$set(this.isError, 'midsummer_drainage_goal_start_date' + i, false)
        }
      } else {
        this.$set(this.isError, 'midsummer_drainage_goal_start_date' + i, false)
      }
      // 中干し日数
      if (data.midsummer_drainage_goal_duration !== null) {
        if (data.midsummer_drainage_goal_duration < 1 || data.midsummer_drainage_goal_duration > 100) {
          this.$set(this.errorMessages, 'midsummerDrainageGoalDurationErrorMessage', '中干し日数は1以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'midsummer_drainage_goal_duration' + i, true)
        } else if (!Number.isInteger(data.midsummer_drainage_goal_duration)) {
          this.$set(this.errorMessages, 'midsummerDrainageGoalDurationErrorMessage', '中干し日数は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'midsummer_drainage_goal_duration' + i, true)
        } else {
          this.$set(this.isError, 'midsummer_drainage_goal_duration' + i, false)
        }
      } else {
        this.$set(this.isError, 'midsummer_drainage_goal_duration' + i, false)
      }
      // 中干し開始日と中干し日数が片方だけ入力されている場合はエラー
      if (data.midsummer_drainage_goal_start_date !== null && data.midsummer_drainage_goal_duration === null) {
        this.$set(this.errorMessages, 'midsummerDrainageLackErrorMessage', '中干し開始日と中干し日数は併せて入力してください。')
        isError = false
        this.$set(this.isError, 'midsummer_drainage_goal_duration' + i, true)
      }
      if (data.midsummer_drainage_goal_start_date === null && data.midsummer_drainage_goal_duration !== null) {
        this.$set(this.errorMessages, 'midsummerDrainageLackErrorMessage', '中干し開始日と中干し日数は併せて入力してください。')
        isError = false
        this.$set(this.isError, 'midsummer_drainage_goal_start_date' + i, true)
      }
    }

    return varietyGrowthNameFlag && userNameFlag && groupNameFlag && actualYieldPriceFlag && fieldColorFlag && incomeFlag && actualYieldSumFlag && planYieldSumFlag && isError
  }

  private doPlantDelete () {
    (async () => {
      this.showLoading = true
      const result = await PlantDeleteApi.doPlantDelete(this.$route.params.plant_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '作付けを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/plant').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private changeGroupId () {
    const accountIdData = this.accountData.filter((data: any) => data.user_id === this.plantData.planting_group.company_user_id)
    if (accountIdData.length !== 0) {
      this.plantData.planting_group.group_id = accountIdData[0].group_id
      Vue.prototype.$alert.toast({ text: 'グループを生産者のグループに変更しました。', type: 0 })
    }
  }

  private doSelectField () {
    this.isSelectedField = this.plantData.plantings
    this.showFieldSelectModal = true
  }

  private closeFieldSelectModal () {
    this.isSelectedField = []
    this.showFieldSelectModal = false
  }

  private doCancel () {
    this.$router.push('/plant').catch(e => {})
  }
}
